import React from "react";

import { Dropdown } from "@packages/ds";

import useUniqueId from "Libs/useUniqueId";
import { sendPendoEventDropdownItem } from "Store/analytics/pendoFunctions";

// We're not extending the DS props directly to avoid confusion with prop names
interface ConsoleCheckboxItemProps
  extends Omit<React.ComponentProps<typeof Dropdown.CheckboxItem>, "id"> {
  analyticId?: string;
  id?: string;
  onCheckedChanged?: (checked: boolean) => void; // Console app uses this name
}

const CheckboxItem = React.forwardRef<
  React.ComponentRef<typeof Dropdown.CheckboxItem>,
  ConsoleCheckboxItemProps
>(function CheckboxItem(
  { id, analyticId, onSelect, onCheckedChanged, ...props },
  forwardedRef
) {
  // Use the console-specific unique ID generator
  const uniqueID = useUniqueId();
  const itemId = id || `checkbox-${uniqueID}`;

  // Analytics tracking
  const handleSelect = event => {
    sendPendoEventDropdownItem({
      analyticId: analyticId || id,
      type: "checkbox",
      checked: props.checked
    });

    if (onSelect) {
      onSelect(event);
    }
  };

  // Map console's onCheckedChanged to DS component's onCheckedChange
  const handleCheckedChange = (checked: boolean) => {
    if (onCheckedChanged) {
      onCheckedChanged(checked);
    }
  };

  return (
    <Dropdown.CheckboxItem
      {...props}
      id={itemId}
      onSelect={handleSelect}
      onCheckedChange={handleCheckedChange}
      ref={forwardedRef}
    />
  );
});

export default CheckboxItem;
